import React from "react";
import type { GatsbyBrowser } from "gatsby";

import "./src/styles/reset.scss";
import "./src/styles/main.scss";
import "@fontsource/bebas-neue/latin-400.css";
import "@fontsource-variable/nunito/wght.css";

import CookieBanner from "./src/components/cookie-banner/cookie-banner";
import {
  loadAnalytics,
  trackPageView,
  hasAnalyticsConsent,
} from "./src/utils/analytics";
import { captureGclid } from "./src/utils/ads-attribution";

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  // Honour consent stored in a previous visit.
  if (hasAnalyticsConsent()) loadAnalytics();
  // Ad clicks always arrive as full page loads, so checking the landing URL
  // once is enough - client-side navigations never carry a gclid.
  captureGclid(window.location.search);
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  trackPageView(location.pathname + location.search);
};

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
    <>
      {element}
      <CookieBanner />
    </>
);